var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 6.68688C11.3828 6.49162 11.3828 6.17504 11.1875 5.97977C10.9923 5.78451 10.6757 5.78451 10.4804 5.97977L7.50065 8.95955L6.52087 7.97977C6.32561 7.78451 6.00903 7.78451 5.81376 7.97977C5.6185 8.17504 5.6185 8.49162 5.81376 8.68688L7.1471 10.0202C7.34236 10.2155 7.65894 10.2155 7.85421 10.0202L11.1875 6.68688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50065 0.833328C4.54261 0.833328 1.33398 4.04195 1.33398 8C1.33398 11.958 4.54261 15.1667 8.50065 15.1667C12.4587 15.1667 15.6673 11.958 15.6673 8C15.6673 4.04195 12.4587 0.833328 8.50065 0.833328ZM2.33398 8C2.33398 4.59424 5.0949 1.83333 8.50065 1.83333C11.9064 1.83333 14.6673 4.59424 14.6673 8C14.6673 11.4058 11.9064 14.1667 8.50065 14.1667C5.0949 14.1667 2.33398 11.4058 2.33398 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.28af330c0aeb510d2c1a7a47a28a0b9e.svg";
export { ForwardRef as ReactComponent };